import { createFileRoute, notFound } from "@tanstack/react-router";
import { ArticlePage, ArticleNotFound, articleHead } from "@/pages/ArticlePage";
import { findPostBySlug } from "@/data/blog/posts";

export const Route = createFileRoute("/de/artikel/$slug")({
  loader: ({ params }) => {
    const post = findPostBySlug(params.slug, "de");
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) =>
    loaderData ? articleHead(loaderData.post, "de") : { meta: [{ title: "Artikel | MI Support" }] },
  notFoundComponent: () => <ArticleNotFound locale="de" />,
  component: RouteComponent,
});

function RouteComponent() {
  const { post } = Route.useLoaderData();
  return <ArticlePage post={post} locale="de" />;
}
